import { AsyncPipe, Location } from '@angular/common';
import { Component, Directive, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { EmailPreviewNavComponent } from '../../components/email-preview-nav/email-preview-nav.component';
import { getPreviewPaths, PreviewRoute } from '../../utils/get-preview-paths';

const findCurrentRoute = (routes: PreviewRoute[]) => (source: Observable<{ name?: string }>) =>
  source.pipe(map(({ name }) => routes.find(r => r.name === name)));

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'iframe#render-frame',
  standalone: true,
})
class EmailPreviewIframeConnectorDirective {
  public elRef = inject(ElementRef<HTMLIFrameElement>);
  public activatedRoute = inject(ActivatedRoute);
  public sanitizer = inject(DomSanitizer);
  public location = inject(Location);

  public frameUrl$ = this.activatedRoute.params.pipe(
    takeUntilDestroyed(),
    filter(({ mode, name }) => mode && name),
    map(({ mode, name, index }) => {
      const { origin, pathname } = window.location;
      const base = `${origin}${pathname}`;

      // todo: make it work without hashbang, nginx changes required
      return `${base}/#/${mode}/${name}/${index || 0}`;
    }),
  );

  public ngOnInit() {
    this.frameUrl$.subscribe(url => {
      this.elRef.nativeElement.src = url;
    });
  }
}

@Component({
  standalone: true,
  selector: 'email-preview-page',
  template: `
    <iframe id="render-frame"></iframe>
    <email-preview-nav [active]="(activeRoute$ | async)!" [routes]="routes" class="nav" />
  `,
  styleUrls: ['./preview-page.component.less'],
  imports: [AsyncPipe, EmailPreviewNavComponent, EmailPreviewIframeConnectorDirective],
})
export class PreviewPageComponent {
  public routes = getPreviewPaths().reverse();
  public activeRoute$ = inject(ActivatedRoute).params.pipe(
    takeUntilDestroyed(),
    findCurrentRoute(this.routes),
  );
}
